// extracted by mini-css-extract-plugin
module.exports = {"w-65":"style_w-65__1ejIJ","w-90":"style_w-90__1BnzV","bingo-scrollbar":"style_bingo-scrollbar__QHZrs","roundStart":"style_roundStart__3nyly","roundTitle":"style_roundTitle__2NK0v"};